/* @flow */

import React from 'react';
import { Message, Embed } from 'semantic-ui-react';

type Props = {
  content: CatalogPageContent,
};

const View = ({ content }: Props) => {
  if (content.youtubeId) {
    return (
      <Embed
        id={content.youtubeId}
        placeholder={content.thumbnail}
        source="youtube"
      />
    );
  }

  return <Message icon="info" header="Aucune vidéo spécifiée" />;
};

export default View;



// WEBPACK FOOTER //
// ./src/modules/catalog/plugins/youtube/View.js